var r = [
  {
    value: "JU",
    label: "Jura"
  },
  {
    value: "GE",
    label: "Genf"
  },
  {
    value: "NE",
    label: "Neuenburg"
  },
  {
    value: "VS",
    label: "Wallis"
  },
  {
    value: "VD",
    label: "Waadt"
  },
  {
    value: "TI",
    label: "Tessin"
  },
  {
    value: "TG",
    label: "Thurgau"
  },
  {
    value: "AG",
    label: "Aargau"
  },
  {
    value: "GR",
    label: "Graubunden"
  },
  {
    value: "SG",
    label: "St. Gallen"
  },
  {
    value: "AI",
    label: "Appenzell Innerrhoden"
  },
  {
    value: "AR",
    label: "Appenzell Ausserrhoden"
  },
  {
    value: "SH",
    label: "Schaffhausen"
  },
  {
    value: "BL",
    label: "Basel-Landschaft"
  },
  {
    value: "BS",
    label: "Basel-Stadt"
  },
  {
    value: "SO",
    label: "Solothurn"
  },
  {
    value: "FR",
    label: "Freiburg"
  },
  {
    value: "ZG",
    label: "Zug"
  },
  {
    value: "GL",
    label: "Glarus"
  },
  {
    value: "NW",
    label: "Nidwalden"
  },
  {
    value: "OW",
    label: "Obwalden"
  },
  {
    value: "SZ",
    label: "Schwyz"
  },
  {
    value: "UR",
    label: "Uri"
  },
  {
    value: "LU",
    label: "Luzern"
  },
  {
    value: "BE",
    label: "Bern"
  },
  {
    value: "ZH",
    label: "Zürich"
  }
], n = {
  de: {
    AG: "Aargau",
    AI: "Appenzell Innerrhoden",
    AR: "Appenzell Ausserrhoden",
    BE: "Bern",
    BL: "Basel-Landschaft",
    BS: "Basel-Stadt",
    FR: "Freiburg",
    GE: "Genf",
    GL: "Glarus",
    GR: "Graubünden",
    JU: "Jura",
    LU: "Luzern",
    NE: "Neuenburg",
    NW: "Nidwalden",
    OW: "Obwalden",
    SG: "St. Gallen",
    SH: "Schaffhausen",
    SO: "Solothurn",
    SZ: "Schwyz",
    TG: "Thurgau",
    TI: "Tessin",
    UR: "Uri",
    VD: "Waadt",
    VS: "Wallis",
    ZG: "Zug",
    ZH: "Zürich"
  },
  fr: {
    AG: "Argovie",
    AI: "Appenzell Rh.-Int.",
    AR: "Appenzell Rh.-Ext.",
    BE: "Berne",
    BL: "Bâle-Campagne",
    BS: "Bâle-Ville",
    FR: "Fribourg",
    GE: "Genève",
    GL: "Glaris",
    GR: "Grisons",
    JU: "Jura",
    LU: "Lucerne",
    NE: "Neuchâtel",
    NW: "Nidwald",
    OW: "Obwald",
    SG: "Saint-Gall",
    SH: "Schaffhouse",
    SO: "Soleure",
    SZ: "Schwyz",
    TG: "Thurgovie",
    TI: "Tessin",
    UR: "Uri",
    VD: "Vaud",
    VS: "Valais",
    ZG: "Zoug",
    ZH: "Zurich"
  },
  it: {
    AG: "Argovia",
    AI: "Appenzello Interno",
    AR: "Appenzello Esterno",
    BE: "Berna",
    BL: "Basilea Campagna",
    BS: "Basilea Città",
    FR: "Friburgo",
    GE: "Ginevra",
    GL: "Glarona",
    GR: "Grigioni",
    JU: "Giura",
    LU: "Lucerna",
    NE: "Neuchâtel",
    NW: "Nidvaldo",
    OW: "Obvaldo",
    SG: "San Gallo",
    SH: "Sciaffusa",
    SO: "Soletta",
    SZ: "Svitto",
    TG: "Turgovia",
    TI: "Ticino",
    UR: "Uri",
    VD: "Vaud",
    VS: "Vallese",
    ZG: "Zugo",
    ZH: "Zurigo"
  }
}, a = "kpt-notification-shown";
function i(l) {
  try {
    const e = localStorage.getItem(a);
    return e ? JSON.parse(e)?.[l] !== void 0 : !1;
  } catch {
    return !1;
  }
}
export {
  n as CANTON_NAMES,
  r as CANTON_OPTIONS,
  a as KPT_NOTIFICATION_KEY,
  i as isKptNotificationShown
};

//# sourceMappingURL=address.constants.js.map